<template>
  <div>
    <a-descriptions size="small" bordered>
      <a-descriptions-item label="Número de cuenta">
        {{lawsuits_info.account_number}}
      </a-descriptions-item>
      <a-descriptions-item label="Número expediente">
        {{lawsuits_info.num_file}}
      </a-descriptions-item>
      <a-descriptions-item label="Código juzgado">
        {{lawsuits_info.cod_court}}
      </a-descriptions-item>
      <a-descriptions-item label="ID del banco">
        {{lawsuits_info.id_h_bank}}
      </a-descriptions-item>
      <a-descriptions-item label="Nombre del banco">
        {{lawsuits_info. nombre_banco}}
      </a-descriptions-item>
      <a-descriptions-item label="Clase de depósito">
        {{lawsuits_info.id_h_class_dep}}
      </a-descriptions-item>
      <a-descriptions-item label="Oficina de origen">
        {{lawsuits_info.oficina_origen}}
      </a-descriptions-item>
      <a-descriptions-item label="Oficina de destino">
        {{lawsuits_info.oficina_destino}}
      </a-descriptions-item>
      <a-descriptions-item label="Tipo de demandante">
        {{lawsuits_info.tipo_demanda}}
      </a-descriptions-item>
      <a-descriptions-item label="ID del demandante">
        {{lawsuits_info.id_demandant}}
      </a-descriptions-item>
      <a-descriptions-item label="Nombre del demandante">
        {{lawsuits_info.name_deman}}
      </a-descriptions-item>
      <a-descriptions-item label="Primer apellido">
        {{lawsuits_info.last_name1_deman}}
      </a-descriptions-item>
      <a-descriptions-item label="Segundo apellido">
        {{lawsuits_info.last_name2_deman}}
      </a-descriptions-item>
      <a-descriptions-item label="Quinta parte">
        {{lawsuits_info.quinta_parte}}
      </a-descriptions-item>
      <a-descriptions-item label="Porcentaje">
        {{lawsuits_info.percentage}} %
      </a-descriptions-item>
      <a-descriptions-item label="Valor fijo">
        {{lawsuits_info.ammount_fixed}}
      </a-descriptions-item>
      <a-descriptions-item label="Monto inicial">
        {{lawsuits_info.amount_initial}}
      </a-descriptions-item>
      <a-descriptions-item label="Balance">
        {{lawsuits_info.balance}}
      </a-descriptions-item>
      <a-descriptions-item label="Número de proceso">
        {{lawsuits_info.process_number}}
      </a-descriptions-item>
      <a-descriptions-item v-if="office_consec === false" label="Of. Consec">
        {{lawsuits_info.office_consec}}
      </a-descriptions-item>
      <a-descriptions-item v-if="office_consec === true" label="Of. Consec">
        {{lawsuits_info.office_consec_desc}}
      </a-descriptions-item>
      <a-descriptions-item label="Proceso">
        {{lawsuits_info.proceso}}
      </a-descriptions-item>
      <a-descriptions-item label="Observaciones">
        {{lawsuits_info.observation}}
      </a-descriptions-item>
    </a-descriptions>
    <br>
    <br>
  </div>
</template>

<script>
  export default {
    props: ['lawsuits_info'],
    data () {
      return {
        office_consec: this.$getConfigValue('EMBARGOS_OFFICE_CONSEC_DROPDOWN', 'NO') === 'SI'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/LawsuitsDetails.vue